import React from "react";

import { LayoutTypes } from "../../types/layout";

import Header from "./header/Header";
import Footer from "./footer/Footer";
import { Stores } from "./header";
import Alert from "../alert/Alert";

const Layout = ({
  children,
  headerImage,
  title,
  additionalTitle,
  subtitle,
  stores,
  height,
  buttons,
  news,
  withoutHero,
  withOverlay,
  homePage,
}: LayoutTypes) => {
  return (
    <div>
      <Alert />
      <div className="m-main">
        <Header
          headerImage={headerImage}
          title={title}
          additionalTitle={additionalTitle}
          subtitle={subtitle}
          stores={stores}
          height={height}
          buttons={buttons}
          news={news}
          withoutHero={withoutHero}
          withOverlay={withOverlay}
          homePage={homePage}
        />
        {stores && <Stores />}

        <div className="m-main__wrapper">
          <div className="m-main__content column-alignCenter">{children}</div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
